/**
 * @typedef {{ id: number, code: string, displayName: string }} CompanySource
 * @typedef {{ id: string, companySourceId: number | null, numCases: number, expiration: string, supplierLot: string }} PalletLine
 * @typedef {{ id: string, lines: PalletLine[] }} Pallet
 *
 * @param {Pallet[]} pallets
 * @param {CompanySource[]} companySourceOptions
 * @returns {{ grandTotal: number, bySource: Array<{ companySource: CompanySource, numCases: number }> }}
 */
function summarizeEnteredCasesBySource(pallets, companySourceOptions) {
    const knownSourceIds = new Set(companySourceOptions.map((source) => Number(source.id)));
    const totalsBySourceId = new Map();
    let grandTotal = 0;

    for (const pallet of pallets) {
        for (const line of pallet.lines) {
            const numCases = Number(line.numCases) || 0;
            grandTotal += numCases;

            if (line.companySourceId != null) {
                const sourceId = Number(line.companySourceId);
                if (knownSourceIds.has(sourceId)) {
                    totalsBySourceId.set(sourceId, (totalsBySourceId.get(sourceId) || 0) + numCases);
                }
            }
        }
    }

    return {
        grandTotal,
        bySource: companySourceOptions.map((source) => ({
            companySource: source,
            numCases: totalsBySourceId.get(Number(source.id)) ?? 0,
        })),
    };
}

export { summarizeEnteredCasesBySource };
